__turbopack_context__.v({
  "container": "sectionContainer-module-scss-module__F2g8YG__container",
  "large": "sectionContainer-module-scss-module__F2g8YG__large",
  "narrow": "sectionContainer-module-scss-module__F2g8YG__narrow",
  "small": "sectionContainer-module-scss-module__F2g8YG__small",
});
